import { render, staticRenderFns } from "./VvRadioColor.vue?vue&type=template&id=4e6c046b&scoped=true&"
import script from "./VvRadioColor.vue?vue&type=script&lang=js&"
export * from "./VvRadioColor.vue?vue&type=script&lang=js&"
import style0 from "./VvRadioColor.vue?vue&type=style&index=0&id=4e6c046b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6c046b",
  null
  
)

export default component.exports